export default __webpack_public_path__ + "static/media/hamburger_audio_on_button.495dd98d.png";